import React from 'react';

import { StyledButtonBlock, StyledButton } from './styled';

const FaqButton = () => (
  <StyledButtonBlock>
    <StyledButton>?</StyledButton>
  </StyledButtonBlock>
);

export default FaqButton;
